
export abstract class StorageService {

	private storage: Storage;
	private userId: number = 0;
	constructor(storage: Storage) {
		this.storage = storage;
	}
	public setUserId = (userId: number) => {
		this.userId = userId == null ? 0 : userId;
	}
	private getKey = (key: string, shared: boolean) => {
		return shared ? key : this.userId + key;
	}
	public saveData = (key: string, value: string, shared: boolean = false): void =>
		this.storage.setItem(this.getKey(key, shared), value);

	public getData = (key: string, shared: boolean = false): string =>
		this.storage.getItem(this.getKey(key, shared));

	public removeData = (key: string, shared: boolean = false): void =>
		this.storage.removeItem(this.getKey(key, shared));

	public clearData = (shared: boolean = false): void =>
		this.storage.clear();

	public saveObject = <T>(key: string, value: T, shared: boolean = false): void =>
		this.saveData(key, JSON.stringify(value), shared);

	public getObject = <T>(key: string, shared: boolean = false): T =>
		JSON.parse(this.getData(key, shared)) as T;

	public normalize(v: string, max: number = 10) {
		let t = '';
		for (var ch of v) {
			let r = ch.toLowerCase();
			if (r >= 'a' && r <= 'z' || r >= '0' && r <= '9' || r == '_' || r == '-' || r == '.')
				t += r;
			if (t.length >= max)
				break;
		}
		return t;
	}
}
